import React from "react";
import { useTranslation } from "react-i18next";
import CardType from "../../models/card";

import styles from "./ChallengeCard.module.css";

interface Props {
  card: CardType;
  handleSubmit: (value: boolean) => void;
}

export default function ChallengeCard({ card, handleSubmit }: Props) {
  const [isChallengeAccepted, setIsChallengeAccepted] = React.useState<
    boolean | null
  >(null);
  const { t } = useTranslation();

  function onChangeHandler(event: React.ChangeEvent<HTMLInputElement>) {
    const { nativeEvent } = event;
    const newValue = event.target.value === "true";

    // Handle click event
    //
    // There is a bug that triggers onClick event when using the cursor keys
    // Read more at:
    // - https://github.com/facebook/react/issues/7407
    if (
      nativeEvent instanceof MouseEvent &&
      nativeEvent.clientX !== 0 &&
      nativeEvent.clientY !== 0
    ) {
      handleSubmit(newValue);
    } else {
      // handle keyboard event
      setIsChallengeAccepted(newValue);
    }
  }

  function onKeyUpHandler(event: React.KeyboardEvent) {
    if (event.key === "Enter" || event.key === " ") {
      if (isChallengeAccepted !== null) {
        handleSubmit(isChallengeAccepted);
      }
    }
  }

  return (
    <form className={styles.form}>
      <div className={styles.title}>
        {t("ChallengeCard.title", { card: card.face })}
      </div>

      <div className={`${styles.wrapper} ${styles.accept}`}>
        <input
          type="radio"
          name="suit"
          value="true"
          id="challenge-true"
          className={styles.radio}
          required
          onChange={onChangeHandler}
          onKeyUp={onKeyUpHandler}
        />
        <label
          className={`${styles.label} ${styles.accept}`}
          htmlFor="challenge-true"
        >
          {t("ChallengeCard.yes")}
        </label>
      </div>

      <div className={`${styles.wrapper} ${styles.refuse}`}>
        <input
          type="radio"
          name="suit"
          value="false"
          id="challenge-false"
          className={styles.radio}
          required
          onChange={onChangeHandler}
          onKeyUp={onKeyUpHandler}
        />
        <label
          className={`${styles.label} ${styles.refuse}`}
          htmlFor="challenge-false"
        >
          {t("ChallengeCard.no")}
        </label>
      </div>
    </form>
  );
}
